export const queryKey = {
  alarmSettings: () => ['alarmSettings'],
  marketingAlarmSettings: () => ['marketingAlarmSettings'],
  pocList: () => ['pocList'],
};
